<template>
  <Stack class="questions-view">
    <Stack gap="2">
      <Title>Questionnaires</Title>
      <p>Display links to the questionnaires.</p>
      <div>
        <Toggle v-model="clientPortalStore.portalRequest.ask_for_questionnaires">
          Ask the client to fill the Questionnaires
        </Toggle>

        <YesNoBadge
          :bool="clientPortalStore.portalRequest.ask_for_questionnaires"
          yes-label="Enabled"
          no-label="Disabled"
        />
      </div>
    </Stack>
  </Stack>
</template>

<script setup>
import { Stack, Title, Toggle, YesNoBadge } from '@stakeui';
import { useClientPortalStore } from '@frontend/ui/stores/clientPortalStore';

const clientPortalStore = useClientPortalStore();

defineProps({
  entityExternalId: {
    type: String,
    default: '',
  },
});
</script>
